import { LazyExoticComponent, ReactElement, Suspense } from 'react'

import { LoadingScreen } from '@/components'

// eslint-disable-next-line
const Loadable = (Component: LazyExoticComponent<() => ReactElement>) => (props: {}) => (
  <Suspense fallback={<LoadingScreen />}>
    <Component {...props} />
  </Suspense>
)

export default Loadable
